module.exports = __webpack_public_path__ + "img/37.a690e542.jpg";